import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import ReactModal from 'react-modal';
import { dAPI } from 'appSrc/api';
import { XIcon } from 'appSrc/components/UI';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';
import style from './styles/style.module.css';

import DetailsForm from './DetailsForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';

class ProductDetailsModal  extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            fetching: false,
        };
    }
    componentDidUpdate( prevProps ) {
        if( prevProps.isOpen != this.props.isOpen && this.state.fetching ) {
            this.setState( { fetching: false } );
        }
    }
    getListSlug = ( listid ) => {
        var slug = '';
        for( var i = 0; i < this.props.self.lists.length; i++ ) {
            if( this.props.self.lists[ i ].listid == listid ) {
                slug = this.props.self.lists[ i ].slug;
                break;
            }
        }
        return slug;
    }
    submit = ( data ) => {
        var tagObjects = data.tagObjects || [];
        var tagTexts = tagObjects.map( tag => tag.tagtext );
        delete data.tagObjects;

        var addTags = ( productid ) => {
            var initialTagsText = ( this.props.product.tags || [] ).map( tag => tag.tagtext );
            var newTags = tagObjects.filter( tag => !initialTagsText.includes( tag.tagtext.toLowerCase() ) );
            newTags = newTags.reduce( ( accumulator, currentValue ) => {
                accumulator.push( this.props.addTag( productid, currentValue.tagtext ) );
                return accumulator;
            } , [] );
            return newTags;
        };
        var deleteTags = ( productid ) => {
            var productTags = this.props.product ? this.props.product.tags || [] : [];
            var deletedTags = [];
            productTags.forEach( ( currentValue ) => {
                if( !tagTexts.includes( currentValue.tagtext ) ){
                    deletedTags.push( this.props.deleteTag( productid, currentValue.tagtext ) );
                }
            } );
            return deletedTags;
        };
        if( this.props.type == 'copy' || this.props.type == 'new' ) {
            //copying a product to a new list, all data should be included
            delete data.desireid;
            var listid = data.listid;
            this.setState( { fetching: true } );
            this.props.addNewProductToList( listid, data )
            .then( ( newProduct ) => {
                var retailer = /^(?:https?:\/\/)?([^\/\?\:]+)/.exec( newProduct.originalUrl );
                Mixpanel.track( 'productAdded', {
                    id: newProduct.desireid,
                    name: newProduct.title,
                    price: newProduct.price,
                    retailer: retailer[1] || retailer[0],
                    // brand: '?',
                    date_created: newProduct.dateCreated,
                    like_count: 0,
                    purchase_count: 0,
                    view_count: 0,
                    search_count: 0,
                    share_count: 0,
                    application: 'website',
                    author: newProduct.userid,
                    list: newProduct.listid,
                } );
                return new Promise( ( resolve ) => {
                    setTimeout( () => {
                        resolve( true );
                    }, 250 );
                } )
                .then( () => {
                    var promises = [ ...addTags( newProduct.desireid ), ...deleteTags( newProduct.desireid ) ];
                    if( this.props.type == 'copy' && newProduct.image == null ) {
                        promises.push( this.props.updateProduct( { desireid: newProduct.desireid, image: data.image } ) );
                    }
                    return Promise.all( promises );
                } )
                .then( () => {
                    return new Promise( ( resolve ) => {
                        setTimeout( () => {
                            resolve( true );
                        }, 250 );
                    } );
                } )
                .then( () => {
                    this.closeModal();
                    this.setState( { fetching: false } );
                } );
            } )
            .catch( ( e ) => {
                console.warn( e );
                alert( 'Sorry, we couldn\'t add this product. An error has been submitted, but if you wish to follow up, you can contact us at help@thedesirecompany.com' );
                this.setState( { fetching: false } );
            } );
        } else if( this.props.type == 'edit' ) {
            Promise.all( [ ...addTags( this.props.product.desireid ), ...deleteTags( this.props.product.desireid ) ] )
            .then( () => {
                return this.props.updateProduct( data );
            } )
            .then( ( response ) => {
                var retailer = /^(?:https?:\/\/)?([^\/\?\:]+)/.exec( response.originalUrl );
                var likes = response.likes == null ? 0 : parseInt( response.likes );
                Mixpanel.track( 'productEdited', {
                    id: response.desireid,
                    name: response.title,
                    price: response.price,
                    retailer: retailer[1] || retailer[0],
                    // brand: '?',
                    date_created: response.dateCreated,
                    like_count: likes,
                    // purchase_count: 0,
                    // view_count: 0,
                    // search_count: 0,
                    // share_count: 0,
                    author: response.userid,
                    list: response.listid,
                } );
                return response;
            } )
            .then( () => {
                this.closeModal();
            } );
        }
    }
    closeModal = () => {
        this.setState( { fetching: false } );
        this.props.closeModal();
    }
    deleteProduct = () => {
        var product = this.props.product;
        this.props.deleteProduct( product.desireid )
        .then( () => {
            var retailer = /^(?:https?:\/\/)?([^\/\?\:]+)/.exec( product.originalUrl );
            var likes = !product.likes ? 0 : parseInt( product.likes );
            Mixpanel.track( 'productDeleted', {
                id: product.desireid,
                name: product.title,
                price: product.price,
                retailer: retailer[1] || retailer[0],
                // brand: '?',
                date_created: product.dateCreated,
                like_count: likes,
                // purchase_count: 0,
                // view_count: 0,
                // search_count: 0,
                // share_count: 0,
                author: product.userid,
                list: product.listid,
            } );

            let url = 'lists';
            if(this.props.self.user.userid == product.userid) {
                url = 'my-lists';
            }
            this.props.redirect( `/app/${url}/${product.listid}` );
            this.props.closeModal();
        } );
    }
    render() {
        return (
            <ReactModal
            isOpen={ this.props.isOpen }
            contentLabel="Product Details"
            onRequestClose={ this.closeModal }
            className={ `modal-popup ${ style.productEditModal }` }
            overlayClassName='modal-overlay' >
                <div className='close-button' onClick={ this.closeModal }>
                    <XIcon size={ 24 } />
                </div>
                <div className={ style.modalContent }>
                    <div className={ style.titleBar }>
                        <h2>Edit This Product</h2>
                    </div>
                    <div style={ { position: 'relative' } }>
                        <DetailsForm
                        type={ this.props.type }
                        initialValues={ this.props.product }
                        product={ this.props.product }
                        nextStep={ this.submit }
                        showLists={ this.props.showLists }
                        deleteProduct={ this.deleteProduct }
                        fetching={ this.state.fetching }
                        error={ this.state.error }/>
                    </div>
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </ReactModal>
        );
    }
}
ProductDetailsModal.defaultProps = {
    isOpen: false,
    showLists: false,
    product: {},
};

const mapStateToProps = (state) => {
    return {
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
        self: state.self,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addNewProductToList: ( listId, data ) => {
            delete data.tags;
            return dAPI.post( `/lists/${ listId }/desires`, data );

        },
        updateProduct: ( data ) => {
            delete data.tags;
            return dAPI.patch( `/desires/${ data.desireid }`, dAPI.clean.product( data ) );

        },
        redirect: ( url ) => {
            dispatch( push( url ) );
        },
        deleteProduct: ( productId ) => {
            return dAPI.delete( `/desires/${ productId }` );

        },
        addTag: ( desireid, newTag ) => {
            return dAPI.post( `/desires/${ desireid }/tag`, { tag: newTag } );

        },
        deleteTag: ( desireid, tagtext ) => {
            return dAPI.delete( `/desires/${ desireid }/tag/${ tagtext }` );

        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ProductDetailsModal );
